import React from 'react'
import './NotificationModel.scss';

const NotificationModel = ({ children }) => {
    return (
        <div className="notification-model-container">
            <div className="notification-model-contain">
                {children}
            </div>
        </div>
    )
}

export default NotificationModel